import React, { useState, useEffect, useRef} from 'react';
import SortableTree , {
    addNodeUnderParent
} from 'react-sortable-tree';
import FileExplorerTheme from 'react-sortable-tree-theme-minimal';
import 'react-sortable-tree/style.css'; // This only needs to be imported once in your app
import { useDispatch } from "react-redux"
import { COMMON_SERVICES } from 'redux/reduxToolkitServices/_commonServices/commonServices';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import { useHookstate } from "@hookstate/core";
import { SITEID_GLOBAL_STATE } from "globalStore/globalStore";
 
export const Tree = () => {
  const dispatch = useDispatch()
  const getNodeKey = ({ treeIndex }) => treeIndex;

  const { siteId } = useHookstate(SITEID_GLOBAL_STATE);

  useEffect(() => {
    dispatch(COMMON_SERVICES.getFoodMenuTabServices(siteId.get()));
  },[]);

  const [treeData, setTreeData] = useState([
    { title: "Chicken", children: [{ title: "Egg" }] },
    { title: "Fish", children: [{ title: "fingerline" }] },
  ]);
  const inputEl = useRef();
  function addNodeSibling(rowInfo) {
    let { path } = rowInfo;

    const value = inputEl.current.value;

    if (value === "") {
      inputEl.current.focus();
      return;
    }

    let newTree = addNodeUnderParent({
      treeData: treeData,
      parentKey: path[path.length - 2],
      expandParent: true,
      getNodeKey,
      newNode: {
        title: value
      }
    });

    setTreeData(newTree.treeData);

    inputEl.current.value = "";
  }

  return (
    <div style={{ height: 400 }}>
      <SortableTree
        treeData={treeData}
        onChange={(treeData) => setTreeData(treeData)}
        theme={FileExplorerTheme}
        canDrag={({ node }) => node.dragDisabled}
        generateNodeProps={(rowInfo) => ({
            buttons: [
              <div style={{display:"flex",alignItems:"center"}}>
                <div>
                    <button><ArrowUpwardIcon/></button>
                    <button><ArrowDownwardIcon/></button>
                </div>
                <div>
                    <input ref={inputEl} type="text"/>
                </div>
                <div>
                </div>
                <div>
                    <button
                    label="Add Sibling"
                      onClick={() => addNodeSibling(rowInfo)}
                    >
                    Add Data
                    </button>
                    <button label="Delete" 
                    >
                    Remove
                    </button>
                </div>
              </div>
            ],
            style: {
              height: "50px",
            }
          })}
      />
    </div>
  );
};